import React from 'react';

import Modal from '../../Modal/Modal';
import PlaceDetail from '../../Place/PlaceDetail';
import MapResidenceDetail from '../../Residence/MapResidenceDetail';

const MapOverlayModals = ( {
  modalState,
  modalRootId,
  modalNavBtns,
  modalHeaderData,
  onClose,
  setModalNavBtns,
  setModalHeaderData,
} ) => (
  <>
    {modalState.isOpen && modalState.type === 'place' && (
      <Modal
        modalClassName="modal--anchored"
        modalRootId={modalRootId}
        isOpen={modalState.isOpen}
        handleModalHide={onClose}
        showBlur
        showCloseButton
        title={modalState.data?.pin?.label_text || modalState.data?.pin?.modal_title || 'Place Details'}
        navBtns={modalNavBtns}
      >
        <PlaceDetail
          uuid={modalState.data?.pin?.uuid}
          parent="modal"
          setModalNavBtns={setModalNavBtns}
        />
      </Modal>
    )}

    {modalState.isOpen && modalState.type === 'unit' && (
      <Modal
        modalClassName="modal--anchored"
        modalRootId={modalRootId}
        isOpen={modalState.isOpen}
        handleModalHide={onClose}
        showBlur
        showCloseButton
        title={modalState.data?.info?.label_text}
        navBtns={modalNavBtns}
        headerData={modalHeaderData}
      >
        <MapResidenceDetail
          uuid={modalState.data?.info?.uuid}
          data={modalState.data?.info}
          setModalNavBtns={setModalNavBtns}
          setModalHeaderData={setModalHeaderData}
        />
      </Modal>
    )}
  </>
);

export default MapOverlayModals;
